const BookingFlowStep = {
    Calendar: 'calendar',
    Products: 'products',
    Times: 'times',
}

export default BookingFlowStep;
